import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import parse from 'html-react-parser';
import { Button, Modal, Typography } from 'antd';
import {
  formatDate,
  formatDateTime,
  getResolveStatusText,
} from '../../../utils/formatter';
import { AppealAnswer } from '../../../model/AppealAnswer';
import { File } from '../../../model/File';
import DocumentBox from '../../InfoLabel/DocumentBox/DocumentBox';
import Constants from '../../../constants/constants';
import { AppealApproval } from '../../../model/AppealApproval';
import AppealDescription from '../../Appeal/AppealDescription/AppealDescription';
import { AppealResolve } from '../../../model/AppealResolve';
import { useAppeal } from '../../../context/appeal/AppealContext';
import { Context } from '../../../index';

interface TabAppealAnswerRowProps {
  appealId: number;
  appealAnswer: AppealAnswer;
  setExpanded: Dispatch<SetStateAction<boolean>>;
}

const TabAppealAnswerRow = (props: TabAppealAnswerRowProps): JSX.Element => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [comment, setComment] = useState('');
  const { store } = useContext(Context);
  const { solveHandler, setupAnswers } = useAppeal();

  const activeResolve = props.appealAnswer.appealResolves.find(
    (resolve) =>
      resolve.director.id === store.getUserId() &&
      resolve.isConfirm === null &&
      props.appealAnswer.isSolved === null
  );

  const handleApproval = (status: boolean, comment?: string) => {
    const approvalStatus: AppealApproval = {
      comment: comment,
      isConfirm: status,
    };
    if (activeResolve !== undefined) {
      props.setExpanded((prev) => !prev);
      store.setAppealApproval(activeResolve.id, approvalStatus).then((res) => {
        if (res) {
          solveHandler(props.appealId);
          setupAnswers(props.appealAnswer.id);
        }
      });
    }
  };

  return (
    <>
      {props.appealAnswer?.executorText && (
        <div className="tabNotificationRow">
          <Typography.Paragraph className="tabNotificationRow__title">
            Ответ исполнителя:
          </Typography.Paragraph>
          <div className="tabNotificationRow__text">
            {parse(props.appealAnswer.executorText)}
          </div>
        </div>
      )}
      {props.appealAnswer?.files?.length > 0 && (
        <div className="tabNotificationRow">
          <Typography.Paragraph className="tabNotificationRow__title">
            Документы:
          </Typography.Paragraph>
          <div className="tabNotificationRow__files">
            {props.appealAnswer.files.map((file: File) => {
              return <DocumentBox file={file} key={file.id} />;
            })}
          </div>
        </div>
      )}
      <div className="tabNotificationRow">
        <Typography.Paragraph className="tabNotificationRow__title">
          Дата:
        </Typography.Paragraph>
        <div className="tabNotificationRow__text">
          {formatDateTime(props.appealAnswer.createdAt)}
        </div>
      </div>

      {props.appealAnswer.holdTo && (
        <div className="tabNotificationRow">
          <Typography.Paragraph className="tabNotificationRow__title">
            Дата отложенного решения:
          </Typography.Paragraph>
          <div className="tabNotificationRow__text">
            {formatDate(props.appealAnswer.holdTo)}
          </div>
        </div>
      )}

      <div className="tabNotificationRow">
        <Typography.Paragraph className="tabNotificationRow__title">
          Согласование:
        </Typography.Paragraph>
        <div className="tabNotificationRow__text">
          {props.appealAnswer.appealResolves.map((resolve: AppealResolve) => {
            return (
              <div className="directorMainContainer" key={resolve.director.id}>
                <div className="directorSubContainer">
                  <div className="directorName">
                    {resolve.director.lastName} {resolve.director.firstName}{' '}
                    {resolve.director.middleName}
                  </div>
                  <div className="directorStatusContainer">
                    <div
                      className={`statusRound statusRound-${resolve.isConfirm}`}
                    />
                    <span className="directorStatus">
                      {getResolveStatusText(resolve.isConfirm)}
                    </span>
                  </div>
                </div>
                <div className="directorDescription">
                  {resolve.comment && (
                    <div>
                      <p>{parse(resolve.comment)}</p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {store.hasRole(Constants.directorRole) && activeResolve && (
        <>
          <Button.Group>
            <Button type="primary" onClick={() => handleApproval(true)}>
              Согласовать
            </Button>
            <Button
              type="primary"
              danger
              onClick={() => setIsModalVisible(true)}
            >
              Отклонить
            </Button>
          </Button.Group>
          <Modal
            className="rejectContainer"
            title="Причина отклонения"
            visible={isModalVisible}
            wrapClassName="rejectionModal"
            onCancel={() => {
              setIsModalVisible(false);
            }}
            footer={[
              <Button
                className="rejectButton"
                key="submit"
                type="primary"
                onClick={() => {
                  handleApproval(false, comment);
                  setIsModalVisible(false);
                }}
              >
                Подтвердить отклонение
              </Button>,
            ]}
          >
            <div>
              <AppealDescription
                data={comment}
                setDescription={setComment}
                label={'Причина отклонения'}
              />
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default TabAppealAnswerRow;
